import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useAdultModeQuery } from "@/hooks";
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import absoluteURL from "@/lib/absoluteURL";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(channel, link, course, adultMode) {
  var _link$values, _channel$genres, _channel$genres$;

  var viewType = link === null || link === void 0 ? void 0 : (_link$values = link.values) === null || _link$values === void 0 ? void 0 : _link$values.view_type;
  var url = link === null || link === void 0 ? void 0 : link.url;
  var genre = (channel === null || channel === void 0 ? void 0 : (_channel$genres = channel.genres) === null || _channel$genres === void 0 ? void 0 : (_channel$genres$ = _channel$genres[0]) === null || _channel$genres$ === void 0 ? void 0 : _channel$genres$.name) || "";
  var trialText = course !== null && course !== void 0 && course.trial_flag ? " | ".concat(course === null || course === void 0 ? void 0 : course.trialTerm, "\u30C8\u30E9\u30A4\u30A2\u30EB\u5B9F\u65BD\u4E2D") : "";

  switch (viewType) {
    case "live_schedule":
      if (adultMode) {
        var _config$host;

        return {
          title: "".concat(channel === null || channel === void 0 ? void 0 : channel.name, " - ").concat(link === null || link === void 0 ? void 0 : link.title, " | SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)"),
          keywords: "".concat(channel === null || channel === void 0 ? void 0 : channel.name, ",SPOOX EX,\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1,\u756A\u7D44\u8868"),
          description: "".concat(link === null || link === void 0 ? void 0 : link.title, "\u3002SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)\u3067\u306F\u3001").concat(channel === null || channel === void 0 ? void 0 : channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config === null || config === void 0 ? void 0 : (_config$host = config.host) === null || _config$host === void 0 ? void 0 : _config$host.adult).concat(routes === null || routes === void 0 ? void 0 : routes.channelDetail(channel === null || channel === void 0 ? void 0 : channel.id, url)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      } else {
        return {
          title: "".concat(channel.name, "\u3010").concat(genre, "\u3011 - ").concat(link.title, " \u306E\u52D5\u753B\u914D\u4FE1 | SPOOX"),
          keywords: "".concat(channel.name, ",SPOOX,\u30B9\u30D7\u30FC\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1,\u756A\u7D44\u8868,\u30B9\u30AB\u30D1\u30FC\uFF01"),
          description: "".concat(link.title, "\u3002SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001").concat(channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config.host.vod).concat(routes.channelDetail(channel.id, url)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      }

    case "palette":
      if (adultMode) {
        return {
          title: "".concat(channel.name, " - ").concat(link.title, " | SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)"),
          keywords: "".concat(channel.name, ",SPOOX EX,\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1"),
          description: "".concat(link.title, "\u3002SPOOX EX(\u30B9\u30D7\u30FCa\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)\u3067\u306F\u3001").concat(channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config.host.adult).concat(routes.channelDetail(channel.id, url)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      } else {
        return {
          title: "".concat(channel.name, "\u3010").concat(genre, "\u3011 - ").concat(link.title, " \u306E\u52D5\u753B\u914D\u4FE1 | SPOOX"),
          keywords: "".concat(channel.name, ",SPOOX,\u30B9\u30D7\u30FC\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1,\u30B9\u30AB\u30D1\u30FC\uFF01"),
          description: "".concat(link.title, "\u3002SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001").concat(channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config.host.vod).concat(routes.channelDetail(channel.id, url)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      }

    case "canvas":
    default:
      if (adultMode) {
        return {
          title: "".concat(channel.name, " | SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)"),
          keywords: "".concat(channel.name, ",SPOOX EX,\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1"),
          description: "SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)\u3067\u306F\u3001".concat(channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config.host.adult).concat(routes.channelDetail(channel.id, url)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      } else {
        return {
          title: "".concat(channel.name, "\u3010").concat(genre, "\u3011\u306E\u52D5\u753B\u914D\u4FE1 | SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)"),
          keywords: "".concat(channel.name, ",SPOOX,\u30B9\u30D7\u30FC\u30AF\u30B9,\u52D5\u753B\u914D\u4FE1,\u30B9\u30AB\u30D1\u30FC\uFF01"),
          description: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001".concat(channel.name, "\u306E\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
          og: {
            type: "article",
            url: "".concat(config.host.vod).concat(routes.channelDetail(channel.id)),
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          },
          twitter: {
            title: "SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9) ".concat(channel === null || channel === void 0 ? void 0 : channel.name, " \u6708\u984D").concat(course === null || course === void 0 ? void 0 : course.price, "\u5186").concat(trialText),
            card: "summary",
            image: absoluteURL({
              url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl,
              adultMode: adultMode
            })
          }
        };
      }

  }
}
export default function ChannelDetailMetaTags(_ref) {
  var channel = _ref.channel,
      link = _ref.link,
      course = _ref.course;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var props = tags(channel, link, course, adultMode);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}